// @ts-check

/**
 * @file Shared task state labels and options.
 */

import _ from "gettext-universal/build/src/translate.js"

/** @typedef {"open" | "confirmed" | "waiting" | "inactive" | "closed"} TaskStateValue */

/** @typedef {{text: string, value: TaskStateValue}} TaskStateOption */

/**
 * Translates a task state for display.
 * @param {string | null | undefined} state Task state value.
 * @returns {string} Translated state label.
 */
export function translatedTaskState(state) {
  if (!state) return "-"
  if (state === "closed") return _("Closed")
  if (state === "confirmed") return _("Confirmed")
  if (state === "inactive") return _("Inactive")
  if (state === "open") return _("Open")
  if (state === "waiting") return _("Waiting")
  return state
}

/**
 * Builds selectable task state options.
 * @returns {TaskStateOption[]} Task state select options.
 */
export function taskStateOptions() {
  return [
    {text: translatedTaskState("open"), value: "open"},
    {text: translatedTaskState("confirmed"), value: "confirmed"},
    {text: translatedTaskState("waiting"), value: "waiting"},
    {text: translatedTaskState("inactive"), value: "inactive"},
    {text: translatedTaskState("closed"), value: "closed"}
  ]
}
